module.exports = __webpack_public_path__ + "img/Group 34293@2x.bf500807.png";